import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronRightBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m13.879 12-6.94-6.94 2.122-2.12L18.12 12l-9.06 9.06-2.122-2.12L13.88 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowChevronRightBold;
